import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import 'bootstrap/dist/css/bootstrap.css';
import '../public/assets/css/style.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import { installPageViewTracker } from "@/plugins/pageViews";      // contador POR PÁGINA (interno)
import { installSiteVisitsTracker } from "@/plugins/siteVisits";   // contador GLOBAL (30min, visible)

const app = createApp(App);

const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(Toast);

installSiteVisitsTracker({ router, pinia });

installPageViewTracker({ router, pinia });

app.mount('#app');
